import * as THREE from "three";
import { SCENE_DEFAULTS } from "@/shared/config/constants";
import { RoomEnvironment } from "three/examples/jsm/environments/RoomEnvironment.js";

export const ENVIRONMENT = {
  MAP_INTENSITY: SCENE_DEFAULTS.environmentMapIntensity,
};

/**
 * Builds the neutral studio IBL environment map: a soft, even `RoomEnvironment`
 * (matching donmccurdy's three-gltf-viewer "Neutral" preset) prefiltered into a
 * PMREM map. Used for lighting/reflections only — the solid background colour
 * set on the scene is left untouched.
 *
 * The bundled equirectangular HDRI (`public/environment/furniture_ton.hdr`) is
 * kept in the repo as an alternative lighting source but is not wired up here.
 *
 * Returns the generated env map so the caller can dispose it on teardown.
 */
export function createNeutralEnvironment(
  renderer: THREE.WebGLRenderer,
): THREE.Texture {
  const pmrem = new THREE.PMREMGenerator(renderer);
  const envMap = pmrem.fromScene(new RoomEnvironment()).texture;
  pmrem.dispose();
  return envMap;
}
